import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { inPixels, px2rem } from '../utils/helpers/style.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var textAreaAttributesWeb = {
  padding: {
    top: inPixels(28),
    right: inPixels(14),
    bottom: inPixels(14),
    left: inPixels(14)
  },
  sizings: {
    s: {
      fontSize: px2rem(16)
    },
    m: {
      fontSize: px2rem(18)
    },
    l: {
      fontSize: px2rem(18)
    }
  },
  label: {
    padding: {
      top: inPixels(14),
      right: 0,
      bottom: 0,
      left: inPixels(14)
    },
    fontSize: px2rem(18)
  }
};
var textAreaThemeWeb = _objectSpread(_objectSpread({}, textAreaAttributesWeb), {}, {
  variants: {
    condensed: {
      fontSize: px2rem(16),
      label: {
        fontSize: px2rem(16)
      }
    }
  }
});

export { textAreaThemeWeb };
